module.exports = __webpack_public_path__ + "static/media/vector-dark.6270eaef.svg";